"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DispatchActionEventHandlerActiavor = exports.DispatchActionEventHandlerArgs = void 0;
const Registries_1 = require("../../state/Registries");
const Target_1 = require("../../Target");
const EventHandlerType_1 = require("../EventHandlerType");
class DispatchActionEventHandlerArgs {
    constructor(action, dispatchFrom = Target_1.Target.Self) {
        this.action = action;
        this.dispatchFrom = dispatchFrom;
        this.__type = EventHandlerType_1.EventHandlerType.DispatchAction;
        this.__typeName = "DispatchAction";
    }
}
exports.DispatchActionEventHandlerArgs = DispatchActionEventHandlerArgs;
let DispatchActionEventHandlerActiavor = class DispatchActionEventHandlerActiavor {
    activate(sequence, container, handler) {
        container.selectLivingTargets(handler.subject, handler.args.dispatchFrom)
            .forEach(target => container.dispatch(sequence.pushSequence("sequential"), target, handler.args.action));
    }
};
DispatchActionEventHandlerActiavor = __decorate([
    Registries_1.EventHandlers.register(EventHandlerType_1.EventHandlerType.DispatchAction)
], DispatchActionEventHandlerActiavor);
exports.DispatchActionEventHandlerActiavor = DispatchActionEventHandlerActiavor;
